import { stageByID, stageCreate, stageDestroy, stageList, stageUpdate } from '@/services/ventures/stages.service'

export default {
	namespaced: true,
	state: {
		stageList: { meta: { pagination: { total: 0 } } },
		stage: {},
		stageStatus: 'pending',
		stageSaveStatus: 'init',
		stageDeleteStatus: 'init',
	},
	getters: {
		getStageList: s => s.stageList,
		getStage: s => s.stage,
		getStageStatus: s => s.stageStatus,
		getStageSaveStatus: s => s.stageSaveStatus,
		getStageDeleteStatus: s => s.stageDeleteStatus,
	},
	mutations: {
		STAGE_LIST(state, value) { state.stageList = value },
		SET_STAGE(state, value) { state.stage = value },
		STAGE_STATUS(state, value) { state.stageStatus = value },
		STAGE_SAVE_STATUS(state, value) { state.stageSaveStatus = value },
		STAGE_DELETE_STATUS(state, value) { state.stageDeleteStatus = value },
	},
	actions: {
		async fetchStageList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('STAGE_STATUS', 'pending')
			commit('STAGE_LIST', { meta: { pagination: { total: 0 } } })
			try {
				const { data } = await stageList(params)
				commit('STAGE_STATUS', 'init')
				commit('STAGE_LIST', data)
				return data
			} catch (error) {
				commit('STAGE_STATUS', 'init')
				throw error
			}
		},
		async saveStage({ commit }, params) {
			commit('STAGE_SAVE_STATUS', 'pending')
			try {
				const { data } = await stageCreate(params)
				commit('STAGE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('STAGE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateStage({ commit }, params) {
			commit('STAGE_SAVE_STATUS', 'pending')
			try {
				const { data } = await stageUpdate(params)
				commit('STAGE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('STAGE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteStageByID({ commit }, params) {
			commit('STAGE_DELETE_STATUS', 'pending')
			try {
				const { data } = await stageDestroy(params)
				commit('STAGE_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('STAGE_DELETE_STATUS', 'error')
				return error
			}
		},
	},
}
